import React, { Component } from 'react';
import ResetPasswordForm from 'components/forms/Auth/ResetPasswordForm';
import '../style.css';

class ResetPassword extends Component {
  render() {
    return (
      <div className="Account">
        <div className="auth-content text-center mx-auto">
          <h4 className="mt-4 mb-4">Reset your password</h4>
          <ResetPasswordForm />
        </div>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/pages/Account/ResetPassword/index.js